import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;
let pending = null;

// Public café details (address, maps link, hours, delivery links); unset fields are omitted by the API.
export const useCafe = () => {
  const [c, setC] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    pending = pending || api.get("/settings/public").then((r) => { cache = r.data; return r.data; }).catch(() => ({}));
    pending.then(setC);
  }, []);
  return c;
};
export const refreshCafe = () => { cache = null; pending = null; };

// Owner-confirmed contact (24 Oct 2026 email / Guest Journey SOP).
export const PHONE = "+91 80502 90427";
export const TEL = "tel:+918050290427";
export const FLOOR = "3rd floor, Biopeak";
export const ENTRY = "Enter through the Biopeak entrance on the ground floor. Our hostess will guide you to the cafe.";
